<template>
  <!-- 包装内置的 Transition 组件 -->
  <Transition name="my-transition" @before-enter="onBeforeEnter" @enter="onEnter" @after-enter="onAfterEnter"
    @before-leave="onBeforeLeave" @leave="onLeave" @after-leave="onAfterLeave">
    <slot></slot> <!-- 向内传递插槽内容 -->
  </Transition>
</template>

<script lang="ts" setup>
const elTransition = '0.3s height ease-in-out, 0.3s padding-top ease-in-out, 0.3s padding-bottom ease-in-out'

function onBeforeEnter(el:any) {
  el.style.transition = elTransition
  if (!el.dataset) el.dataset = {}

  el.dataset.oldPaddingTop = el.style.paddingTop
  el.dataset.oldPaddingBottom = el.style.paddingBottom

  el.style.height = 0
  el.style.paddingTop = 0
  el.style.paddingBottom = 0
}

// 在元素被插入到 DOM 之后的下一帧被调用
// 用这个来开始进入动画
function onEnter(el:any) {
  // 调用回调函数 done 表示过渡结束
  // 如果与 CSS 结合使用，则这个回调是可选参数
  el.dataset.oldOverflow = el.style.overflow
  if (el.scrollHeight !== 0) {
    el.style.height = el.scrollHeight + 'px'
    el.style.paddingTop = el.dataset.oldPaddingTop
    el.style.paddingBottom = el.dataset.oldPaddingBottom
  } else {
    el.style.height = ''
    el.style.paddingTop = el.dataset.oldPaddingTop
    el.style.paddingBottom = el.dataset.oldPaddingBottom
  }

  el.style.overflow = 'hidden'
}

// 当进入过渡完成时调用。
function onAfterEnter(el:any) {
  el.style.transition = ''
  el.style.height = ''
  el.style.overflow = el.dataset.oldOverflow
}


// 在 leave 钩子之前调用
// 大多数时候，你应该只会用到 leave 钩子
function onBeforeLeave(el:any) {
  if (!el.dataset) el.dataset = {}
  el.dataset.oldPaddingTop = el.style.paddingTop
  el.dataset.oldPaddingBottom = el.style.paddingBottom
  el.dataset.oldOverflow = el.style.overflow

  el.style.height = el.scrollHeight + 'px'
  el.style.overflow = 'hidden'
}

// 在离开过渡开始时调用
// 用这个来开始离开动画
function onLeave(el:any) {
  // 调用回调函数 done 表示过渡结束
  // 如果与 CSS 结合使用，则这个回调是可选参数
  if (el.scrollHeight !== 0) {
    el.style.transition = elTransition
    el.style.height = 0
    el.style.paddingTop = 0
    el.style.paddingBottom = 0
  }
}

// 在离开过渡完成、
// 且元素已从 DOM 中移除时调用
function onAfterLeave(el:any) {
  el.style.transition = ''
  el.style.height = ''
  el.style.overflow = el.dataset.oldOverflow
  el.style.paddingTop = el.dataset.oldPaddingTop
  el.style.paddingBottom = el.dataset.oldPaddingBottom
}


</script>
